import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import { application } from "globals/endpoints";

function CampaignAutoAttendantCell({ value }) {
  const [listOptions, setListOptions] = useState([]);
  useEffect(() => {
    application.post("autoAttendant/listAll").then((response) => {
      setListOptions(response.data.data);
    });
  }, []);
  const matchedRole = listOptions?.find((option) => option.id === value);
  return (
    <>
        <MDTypography variant="caption" fontWeight="medium" color="text">
        {matchedRole == undefined ? "NA" : (matchedRole && matchedRole.extension) }
        </MDTypography>
    </>
  );
}

export default CampaignAutoAttendantCell;


